var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row gutter-md" },
    [
      _vm._l(_vm.getTrainings, function(certificate, index) {
        return _c(
          "div",
          { key: index, staticClass: "col-xs-12 col-sm-4" },
          [
            _c(
              "q-card",
              {
                staticClass: "bg-grey-1 cursor-pointer",
                nativeOn: {
                  click: function($event) {
                    return _vm.showCertificate(certificate)
                  }
                }
              },
              [
                _c("q-card-media", [
                  certificate.group_training_images &&
                  certificate.group_training_images.length > 0
                    ? _c("img", {
                        attrs: { src: _vm.getCertificateImage(certificate) }
                      })
                    : _vm._e(),
                  certificate.group_training_images &&
                  certificate.group_training_images.length == 0
                    ? _c("img", { attrs: { src: _vm.getPlaceholder } })
                    : _vm._e()
                ]),
                _c(
                  "q-card-main",
                  {
                    staticClass: "relative-position cursor-pointer text-center",
                    staticStyle: { "min-height": "100px" }
                  },
                  [
                    _c("div", {
                      staticClass: "line-card bg-primary absolute-top"
                    }),
                    _c("div", { staticClass: "row q-my-sm" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-12 q-subheading text-weight-medium text-primary"
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(certificate.group_training_title) +
                              "\n                    "
                          )
                        ]
                      )
                    ])
                  ]
                ),
                _c("q-card-separator"),
                _c("q-card-main", [
                  _c("div", { staticClass: "row text-faded" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("date")) +
                          ": " +
                          _vm._s(_vm.format(certificate.result_date)) +
                          "\n                    "
                      )
                    ]),
                    _c("div", { staticClass: "col-12" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("percentage")) +
                          ": " +
                          _vm._s(certificate.percent.toFixed(2)) +
                          "%\n                    "
                      )
                    ]),
                    _vm.showPoints
                      ? _c("div", { staticClass: "col-12" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("earned_points")) +
                              ": " +
                              _vm._s(certificate.score) +
                              "\n                    "
                          )
                        ])
                      : _vm._e()
                  ])
                ])
              ],
              1
            )
          ],
          1
        )
      }),
      _vm._l(_vm.getWebcasts, function(certificate, index) {
        return _c(
          "div",
          { key: "w" + index, staticClass: "col-xs-12 col-sm-4" },
          [
            _c(
              "q-card",
              {
                staticClass: "bg-grey-1 cursor-pointer",
                nativeOn: {
                  click: function($event) {
                    return _vm.showCertificateWebcast(certificate)
                  }
                }
              },
              [
                _c("q-card-media", [
                  certificate.webcast_images &&
                  certificate.webcast_images.length > 0
                    ? _c("img", {
                        attrs: {
                          src: _vm.getCertificateImageWebcast(certificate)
                        }
                      })
                    : _vm._e(),
                  certificate.webcast_images &&
                  certificate.webcast_images.length == 0
                    ? _c("img", { attrs: { src: _vm.getPlaceholderWebcast } })
                    : _vm._e()
                ]),
                _c(
                  "q-card-main",
                  {
                    staticClass: "relative-position cursor-pointer text-center",
                    staticStyle: { "min-height": "100px" }
                  },
                  [
                    _c("div", {
                      staticClass: "line-card bg-primary absolute-top"
                    }),
                    _c("div", { staticClass: "row q-my-sm" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-12 q-subheading text-weight-medium text-primary"
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(certificate.webcast_title) +
                              "\n                    "
                          )
                        ]
                      )
                    ])
                  ]
                ),
                _c("q-card-separator"),
                _c("q-card-main", [
                  _c("div", { staticClass: "row text-faded" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("date")) +
                          ": " +
                          _vm._s(_vm.format(certificate.result_date)) +
                          "\n                    "
                      )
                    ]),
                    _c("div", { staticClass: "col-12" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("percentage")) +
                          ": " +
                          _vm._s(certificate.percent.toFixed(2)) +
                          "%\n                    "
                      )
                    ]),
                    _vm.showPoints
                      ? _c("div", { staticClass: "col-12" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("earned_points")) +
                              ": " +
                              _vm._s(certificate.score) +
                              "\n                    "
                          )
                        ])
                      : _vm._e()
                  ])
                ])
              ],
              1
            )
          ],
          1
        )
      }),
      _vm._l(_vm.getLiveClass, function(certificate, index) {
        return _c(
          "div",
          { key: "lc" + index, staticClass: "col-xs-12 col-sm-4" },
          [
            _c(
              "q-card",
              {
                staticClass: "bg-grey-1 cursor-pointer",
                nativeOn: {
                  click: function($event) {
                    return _vm.showCertificateLiveClass(certificate)
                  }
                }
              },
              [
                _c("q-card-media", [
                  certificate.live_class_images &&
                  certificate.live_class_images.length > 0
                    ? _c("img", {
                        attrs: {
                          src: _vm.getCertificateImageLiveClass(certificate)
                        }
                      })
                    : _vm._e(),
                  certificate.live_class_images &&
                  certificate.live_class_images.length == 0
                    ? _c("img", { attrs: { src: _vm.getPlaceholder } })
                    : _vm._e()
                ]),
                _c(
                  "q-card-main",
                  {
                    staticClass: "relative-position cursor-pointer text-center",
                    staticStyle: { "min-height": "100px" }
                  },
                  [
                    _c("div", {
                      staticClass: "line-card bg-primary absolute-top"
                    }),
                    _c("div", { staticClass: "row q-my-sm" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-12 q-subheading text-weight-medium text-primary"
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(certificate.live_class_title) +
                              "\n                    "
                          )
                        ]
                      )
                    ])
                  ]
                ),
                _c("q-card-separator"),
                _c("q-card-main", [
                  _c("div", { staticClass: "row text-faded" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("date")) +
                          ": " +
                          _vm._s(_vm.format(certificate.result_date)) +
                          "\n                    "
                      )
                    ]),
                    _c("div", { staticClass: "col-12" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("percentage")) +
                          ": " +
                          _vm._s(certificate.percent.toFixed(2)) +
                          "%\n                    "
                      )
                    ]),
                    _vm.showPoints
                      ? _c("div", { staticClass: "col-12" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("earned_points")) +
                              ": " +
                              _vm._s(certificate.score) +
                              "\n                    "
                          )
                        ])
                      : _vm._e()
                  ])
                ])
              ],
              1
            )
          ],
          1
        )
      }),
      _vm._l(_vm.getPresentials, function(certificate, index) {
        return _c(
          "div",
          { key: "p" + index, staticClass: "col-xs-12 col-sm-4" },
          [
            _c(
              "q-card",
              {
                staticClass: "bg-grey-1 cursor-pointer",
                nativeOn: {
                  click: function($event) {
                    return _vm.showCertificatePresential(certificate)
                  }
                }
              },
              [
                _c("q-card-media", [
                  certificate.presential_event_images.length > 0
                    ? _c("img", {
                        attrs: {
                          src: _vm.getCertificateImagePresential(certificate)
                        }
                      })
                    : _vm._e(),
                  certificate.presential_event_images.length == 0
                    ? _c("img", {
                        attrs: { src: _vm.getPlaceholderPresential }
                      })
                    : _vm._e()
                ]),
                _c(
                  "q-card-main",
                  {
                    staticClass: "relative-position cursor-pointer text-center",
                    staticStyle: { "min-height": "100px" }
                  },
                  [
                    _c("div", {
                      staticClass: "line-card bg-primary absolute-top"
                    }),
                    _c("div", { staticClass: "row q-my-sm" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-12 q-subheading text-weight-medium text-primary"
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(certificate.presential_event_title) +
                              "\n                    "
                          )
                        ]
                      )
                    ])
                  ]
                ),
                _c("q-card-separator"),
                _c("q-card-main", [
                  _c("div", { staticClass: "row text-faded" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("date")) +
                          ": " +
                          _vm._s(_vm.format(certificate.result_date)) +
                          "\n                    "
                      )
                    ]),
                    _vm.showPoints
                      ? _c("div", { staticClass: "col-12" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("earned_points")) +
                              ": " +
                              _vm._s(certificate.presential_event_score) +
                              "\n                    "
                          )
                        ])
                      : _vm._e(),
                    _c("div", { staticClass: "col-12" })
                  ])
                ])
              ],
              1
            )
          ],
          1
        )
      }),
      _vm.getPresentials.length === 0 &&
      _vm.getTrainings.length === 0 &&
      _vm.getLiveClass.length == 0 &&
      _vm.getWebcasts.length === 0 &&
      _vm.loaded
        ? _c(
            "div",
            { staticClass: "col-xs-12 col-sm-12 text-center" },
            [
              _c(
                "q-card",
                { staticClass: "bg-grey-1" },
                [
                  _c("q-card-main", { staticClass: "relative-position" }, [
                    _c("div", {
                      staticClass: "line-card bg-primary absolute-top"
                    }),
                    _c("div", { staticClass: "row q-my-sm" }, [
                      _c(
                        "div",
                        {
                          staticClass: "col-12 q-subheading text-weight-medium"
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("no_certificates_found")) +
                              "\n                    "
                          )
                        ]
                      )
                    ])
                  ])
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "q-inner-loading",
        { attrs: { visible: !_vm.loaded } },
        [_c("q-spinner-dots", { attrs: { size: 60, color: "secondary" } })],
        1
      ),
      _c("certificate", {
        attrs: {
          show: _vm.show_certificate,
          certificate: _vm.certificate,
          data: _vm.certificate_data
        },
        on: { hideCertificate: _vm.hideCertificate }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }